import React, { useEffect, useMemo, useState } from 'react'
import BasicModalWindow from '../../components/BasicModalWIndow'
import ItemsBasePage from './ItemsBasePage'
import { Button } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'
import { returnSingleDisplayer, useReturnSingleDispplayer } from '../../components/DataDisplayer/dataDisplyerSlice'
import ItemsApp, { IItemModel } from './ItemsApp'
import { useDispatch } from 'react-redux'
import { returnSingleItemDetailsFromList, useReturnAllItems } from './itemsSlice'
import { IDataDisplayer } from '../../components/DataDisplayer/DataDisplayer'
import { useSelector, shallowEqual } from 'react-redux'
import { RootState } from '../../app/store'
import { error } from 'console'
import { handleRequestError } from '../../services/api'
import SelectItems from './SelectItems'
import ItemsList from './ItemsList'

interface IProps {
    itemId: number,
    open: boolean,
    handleClose: () => void,
    refreshItems: () => void,
}

export default function NewItemToContainer(props: IProps) {

    const dispatch = useDispatch()

    const { open, itemId, refreshItems } = props

    const itemsApp = new ItemsApp()

    const [loading, setLoading] = useState<boolean>(false)
    const [selectItemsResetCounter, setSelectItemsResetCounter] = useState(0)

    const [reset, setReset] = useState<boolean>(false)

    /**
     * Handle close
     */
    const handleClose = () => {
        // setReset(true)
        props.handleClose()
        refreshItems()
        setSelectItemsResetCounter(prev => prev + 1) // triggers reset
    }

    /**
     * Add items
     */
    const addItems = (items: number[]) => {
        setLoading(true)

        itemsApp.newItemsToContainer(itemId, items)
            .then(response => {
                setLoading(false)
                handleClose()
            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })
    }


    return(
        <BasicModalWindow
            shown={open}
            handleClose={handleClose}
            title="Add new items"
            size="fullscreen"
            actionButtons={[]}
        >
            <div className={loading ? "freeze-container freeze" : "freeze-container"}>
                {/* <ItemsBasePage dashboardPage={true} customDataDisplayerActionButtons={[
                        {
                            icon: "new",
                            label: "Add items to container",
                            onClick: () => {},
                            customContent: (button, selectedItems) => {
                                return <Button disabled={selectedItems.length > 0 ? false : true} className="general-button admin-style" startIcon={<GenerateIcon icon="new" />} onClick={() => addItems(selectedItems)}>Add items to container</Button>
                            }
                        }
                    ]} /> */}
                    <SelectItems reset={reset} addItems={addItems} />
            </div>
        </BasicModalWindow>
    )
}